import { TopicDto } from '@/Domain/api/Conversation/dto/Topic.dto';
import { TopicFormItem } from '@/Domain/components/Insights/Topics/TopicForm/TopicFormItem';
import { Form } from '@/Domain/components/Shared/Form/Form';

import { useTopicForm } from '@/Domain/hooks/AI/useTopicForm/useTopicForm.hook';

type Props = {
  index: number;
  topicLength: number;
  topic: TopicDto;
};

export const TopicForm = ({ index, topic, topicLength }: Props) => {
  const {
    form,
    handleSubmit,
    handleDelete,
    handleReset,
    MIN_TOPICS,
    setIsEditMode,
    isEditMode,
    isUpdatePending,
  } = useTopicForm(topic);

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)} className="my-4">
        <TopicFormItem
          index={index}
          key={topic.id}
          form={form}
          topic={topic}
          isEditMode={isEditMode}
          minTopics={MIN_TOPICS}
          topicLength={topicLength}
          isUpdatePending={isUpdatePending}
          setIsEditMode={setIsEditMode}
          onDelete={handleDelete}
          onReset={handleReset}
        />
      </form>
    </Form>
  );
};
